import { render, staticRenderFns } from "./bygz_modules.vue?vue&type=template&id=fc445ae4"
import script from "./bygz_modules.vue?vue&type=script&lang=js"
export * from "./bygz_modules.vue?vue&type=script&lang=js"
import style0 from "./bygz_modules.vue?vue&type=style&index=0&id=fc445ae4&prod&lang=css"
import style1 from "./bygz_modules.vue?vue&type=style&index=1&id=fc445ae4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports